module.exports = __webpack_public_path__ + "static/media/pic-2.e2e96add.jpg";